import type { LocaleMessages } from 'shared-types';
import type { GetCourseQualityEvaluationRes } from 'shared-types/responses';

type JobError = NonNullable<GetCourseQualityEvaluationRes['job']>['error'];

/**
 * Maps a background job error code from a failed course quality evaluation
 * to a user-facing locale message. Falls back to the generic failure message
 * for unknown or unmapped codes, and when `error` is null.
 */
const getFailureMessageForCourseEvaluation = (
  error: JobError | null,
  messages: LocaleMessages
): string => {
  switch (error?.code) {
    case 'course_quality_evaluation_failed':
      return messages.courseEvaluationFailedAi;
    case 'course_quality_evaluation_invalid_response':
      return messages.courseEvaluationFailedInvalidResponse;
    case 'failed_by_admin':
      return messages.commonJobCancelledByAdmin;
    case 'ai_config_unavailable':
      return messages.aiToolsErrorConfigUnavailable;
    case 'course_not_found':
      return messages.commonCourseNotFound;
    case 'background_job_not_found':
    default:
      return messages.courseEvaluationFailedGeneric;
  }
};

export default getFailureMessageForCourseEvaluation;
